export const simplifyAddress = (location, features) => {
  if (!location) return null;
  const { text: displayedAddress, latitude, longitude, isReversing = false } = location;
  if (!displayedAddress) return null;

  const addressObject = isReversing ? features : getAddressObject(location, features);
  const postal_code = getAddress(addressObject, 'postcode');
  const borough = getAddress(addressObject, 'locality');
  const place = getAddress(addressObject, 'place');
  const { short: state, full: region } = getAddress(addressObject, 'region');
  const city = place || region;
  const line1 = getStreet(displayedAddress, city);

  const text = `${line1}, ${city}, ${state} ${postal_code}`;
  const simple = {
    line1,
    city,
    ...(place === 'New York' && { borough }),
    state,
    country: 'US',
    postal_code,
    latitude,
    longitude,
  };

  return { text, simple };
};

const getAddressObject = (location, features) => {
  const { text: displayedAddress } = location;
  let addressObject = null;

  features.forEach(feature => {
    const edited_place_name = feature.place_name.replace(', United States', '');
    if (edited_place_name === displayedAddress) {
      feature.place_name = edited_place_name;
      addressObject = feature;
    }
  });

  return addressObject;
};

const getStreet = (displayedAddress, cityName) => {
  const addressDataArray = displayedAddress.split(',');
  addressDataArray.pop(); // addressDataArray without state and postal code

  if (addressDataArray.length > 1) {
    addressDataArray.pop(); // addressDataArray without city
  }

  let line1 = addressDataArray.join(',');

  if (line1.includes(cityName)) {
    const substring = `, ${cityName}`;
    line1 = line1.replace(substring, '');
  }

  return line1;
};

const getAddress = (feature, infoType) => {
  const { context = [] } = feature || {};
  let text = null;

  context.forEach(obj => {
    const { id } = obj;
    if (id.includes(infoType)) {
      if (infoType === 'region') {
        text = {
          short: obj.short_code.replace('US-', ''),
          full: obj.text,
        };
      } else {
        text = obj.text;
      }
    }
  });

  return text || '';
};
